import React from 'react';
import Default from './default';
import Home from './home';

function Index(props) {
	return props.template === 'default' ? <Default {...props} /> : <Home />;
}

export default Index;
